// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STAR = "Ulo\u017e";
export const UNSTAR = "Odeber z ulo\u017een\u00fdch";
